/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { EffectivePortfolioSource } from './EffectivePortfolioSource';
// @ts-ignore
import {
// @ts-ignore
    EffectivePortfolioSourceFromJSON,
// @ts-ignore
    EffectivePortfolioSourceFromJSONTyped,
// @ts-ignore
    EffectivePortfolioSourceToJSON,
} from './EffectivePortfolioSource';

/**
 * 
 * @export
 * @interface EffectivePortfolio
 */
export interface EffectivePortfolio {
    /**
     * 
     * @type {string}
     * @memberof EffectivePortfolio
     */
    supplierId: string;
    /**
     * 
     * @type {string}
     * @memberof EffectivePortfolio
     */
    retailerId: string;
    /**
     * 
     * @type {string}
     * @memberof EffectivePortfolio
     */
    storeId: string;
    /**
     * 
     * @type {EffectivePortfolioSource}
     * @memberof EffectivePortfolio
     */
    source: EffectivePortfolioSource;
    /**
     * 
     * @type {Array<string>}
     * @memberof EffectivePortfolio
     */
    productListIds: Array<string>;
}

/**
 * Check if a given object implements the EffectivePortfolio interface.
 */
// @ts-ignore
export function instanceOfEffectivePortfolio(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "supplierId" in value;
    isInstance = isInstance && "retailerId" in value;
    isInstance = isInstance && "storeId" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "productListIds" in value;

    return isInstance;
}

// @ts-ignore
export function EffectivePortfolioFromJSON(json: any): EffectivePortfolio {
    return EffectivePortfolioFromJSONTyped(json, false);
}

// @ts-ignore
export function EffectivePortfolioFromJSONTyped(json: any, ignoreDiscriminator: boolean): EffectivePortfolio {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'supplierId': json['supplier_id'],
        'retailerId': json['retailer_id'],
        'storeId': json['store_id'],
        'source': EffectivePortfolioSourceFromJSON(json['source']),
        'productListIds': json['product_list_ids'],
    };
}

// @ts-ignore
export function EffectivePortfolioToJSON(value?: EffectivePortfolio | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'supplier_id': value.supplierId,
        'retailer_id': value.retailerId,
        'store_id': value.storeId,
        'source': EffectivePortfolioSourceToJSON(value.source),
        'product_list_ids': value.productListIds,
    };
}

